var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fallbackSrc)?_c('img',{attrs:{"src":_vm.fallbackSrc,"alt":_vm.alt}}):(_vm.src)?_c('img',{ref:"img",attrs:{"src":_vm.imgSrc,"alt":_vm.alt},on:{"load":_vm.onLoad,"error":_vm.onError}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }